import React from 'react';
import BooleanRow from '@library/boolean-row/edit';
import PermanentlyClosed from './PermanentlyClosed';
import TemporaryClosures from './temporary-closures';
import * as c from '../../constants';

type Status = {
  permanentlyClosed: boolean | null;
  hoursMayVary: boolean | null;
  mayRequireAppointment: boolean | null;
  temporaryClosures: any[];
};

type Props = Status & {
  onChange: (change: Partial<Status>) => void;
};

const Edit = function(props: Props) {
  return (
    <>
      <div className="editor__listing__hours__card" data-cy="hours-status">
        <div className="editor__listing__hours__card__header">
          <h4 className="editor__listing__hours__card__title" id="Status">
            {'Status'}
          </h4>
        </div>
        <PermanentlyClosed
          permanentlyClosed={props.permanentlyClosed}
          setPermanentlyClosed={permanentlyClosed =>
            props.onChange({ permanentlyClosed })}
        />
        <BooleanRow
          segmented
          label={c.HOURS_VARY_LABEL}
          description={c.HOURS_VARY_DESCRIPTION}
          value={props.hoursMayVary}
          onChange={hoursMayVary => props.onChange({ hoursMayVary })}
        />
        <BooleanRow
          segmented
          label={c.APPOINTMENT_FIELD_LABEL}
          description={c.APPOINTMENT_DESCRIPTION}
          value={props.mayRequireAppointment}
          onChange={mayRequireAppointment =>
            props.onChange({ mayRequireAppointment })}
        />
      </div>
      <div className="editor__listing__hours__card">
        <TemporaryClosures
          temporaryClosures={props.temporaryClosures}
          setTemporaryClosures={temporaryClosures =>
            props.onChange({ temporaryClosures })}
        />
      </div>
    </>
  );
};

export default Edit;
